export const PlanGetSchema = {
    id: 'id',
    pages: {
        general: {
            pageId: 'general',
            description: 'description',
            enabled: 'enabled',
        },
        gatewayActivation: {
            pageId: 'gatewayActivation',
            connectAnonymously: 'connectAnonymously',
            regkey: 'regkey',
            activationKey: 'activationKey'
        },
        ntp: {
            pageId: 'ntp',
            manageInSmp: 'manageInSmp',
            ntpAuthentication: 'sharedSecretStatus',
            primaryNtpServer: 'primaryServer',
            secondaryNtpServer: 'secondaryServer',
            sharedSecret: 'authKeyID',
            sharedSecretIdentifier: 'authKeyValue',
            updateIntervalMinutes: 'reSyncNtpVal',
        },
        timezone: {
            pageId: 'timeZone',
            manageInSmp: 'manageInSmp',
            localTimeZone: 'localtimezone',
            autoDaylightSavings: 'autoDaylightSavings'
        },
        dns: {
            pageId: 'dns',
            manageInSmp: 'manageInSmp',
            configureDnsServers: 'serversConfiguration',
            configureDnsServersValues: {
                GLOBAL: 'GLOBAL',
                INTERNET: 'INTERNET'
            },
            domainName: 'dnsDomainName',
            enableDnsProxy: 'enableDnsProxy',
            resolveNetworkObjects: 'resolveNetworkObjects',
            firstDnsServer: 'globalDnsServer1',
            secondDnsServer: 'globalDnsServer2',
            thirdDnsServer: 'globalDnsServer3'
        },
        administrators: {
            pageId: 'administrators',
            manageInSmp: 'manageInSmp',
            administrators: 'administrators',
            administratorsSchema: {
                username: 'username',
                password: 'password',
                role: 'role'
            }
        },
        localUsers: {
            pageId: 'localUsers',
            manageInSmp: 'manageInSmp',
            localUsers: 'localUsers',
            localUsersSchema: {
                username: "username",
                password: "password",
                email: "email",
                phoneNumber: "phoneNumber",
                comments: "comments.",
                isRemoteAccessUser: "isRemoteAccessUser"
            }
        },
        firewall: {
            pageId: 'firewall',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            policy: 'policy',
            logAllowedTraffic: 'logAllowedTraffic',
            logAllowedTrafficValue: 'logAllowedTrafficValue',
            logBlockedTraffic: 'logBlockedTraffic',
            logBlockedTrafficValue: 'logBlockedTrafficValue',
        },
        accessPolicy: {
            pageId: 'accessPolicy',
            manageInSmp: 'manageInSmp',
            ruleBaseType: 'ruleBaseType',
            ruleBaseTypeValues: {
                LEGACY: 'LEGACY',
                NEXT_GEN: 'NEXT_GEN',
            },
            legacyRules: 'legacyRules',
            nextGenRules: 'nextGenRules',
            cpAccessRulesSchema: {
                preOutgoingRules: 'preOutgoingRules',
                postOutgoingRules: 'postOutgoingRules',
                preIncomingRules: 'preIncomingRules',
                postIncomingRules: 'postIncomingRules',
            },
            cpRuleSchema: {
                source: 'source',
                destination: 'destination',
                sourceDestinationSchema: {
                    type: 'type',
                    zone: 'zone',
                    ipSingle: 'ipSingle',
                    ipStart: 'ipStart',
                    ipEnd: 'ipEnd',
                    ipNetwork: 'ipNetwork',
                    ipMask: 'ipMask',
                    schemaIpRange: 'schemaIpRange',
                    schemaIpRangeSchema: {
                        ipStart: 'ipStart',
                        ipEnd: 'ipEnd',
                    },
                    schemaNetwork: 'schemaNetwork',
                    schemaNetworkSchema: {
                        ipNetwork: 'ipNetwork',
                        ipMask: 'ipMask'
                    },
                    ipV6Single: 'ipV6Single',
                    ipV6Start: 'ipV6Start',
                    ipV6End: 'ipV6End',
                    ipV6Network: 'ipV6Network',
                    ipV6Prefix: 'ipV6Prefix',
                    ipV6ObjectName: 'ipV6ObjectName',
                    schemaIpV6Range: 'schemaIpV6Range',
                    schemaIpV6RangeSchema: {
                        ipV6Start: 'ipV6Start',
                        ipV6End: 'ipV6End',
                    },
                    schemaIpV6Network: 'schemaIpV6Network',
                    schemaIpV6NetworkSchema: {
                        ipIpV6Network: 'ipV6Network',
                        ipV6Prefix: 'ipV6Prefix'
                    }
                },
                serviceOrApplication: 'serviceOrApplication',
                serviceOrApplicationValues: {
                    SERVICE: 'SERVICE',
                    APPLI: 'APPI',
                },
                service: 'service',
                serviceSchema: {
                    type: "type",
                    customType: "customType",
                    name: "name",
                    ports: "ports",
                    icmpType: "icmpType",
                    icmpCode: "icmpCode",
                    ipProtocol: "ipProtocol"
                },
                application: 'application',
                applicationSchema: {
                    type: "type",
                    predefinedAppId: "predefinedAppId",
                    customUrlValue: "customUrlValue",
                    customUrlName: "customUrlName",
                    customUrlIsRegex: "customUrlIsRegex",
                },
                action: 'action',
                log: 'log',
                description: 'description',
                enabled: 'enabled'
            }
        },
        applicationsAndUrls: {
            pageId: 'applicationsAndUrls',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            blockSecurityRiskCategories: 'blockSecurityRiskCategories',
            blockFileSharingApplications: 'blockFileSharingApplications',
            blockInappropriateContent: 'blockInappropriateContent',
            blockOtherUndesiredApplications: 'blockOtherUndesiredApplications',
            appiBlockList: 'appiBlockList'
        },
        ips: {
            pageId: 'ips',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            policy: 'policy',
            policyValues: {
                strict: 'STRICT',
                standard: 'STANDARD',
                custom: 'CUSTOM'
            },
            detectOnlyMode: 'detectOnlyMode',
        },
        traditionalAntiVirus: {
            pageId: 'traditionalAntiVirus',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            scanIncoming: 'scanIncoming',
            scanOutgoing: 'scanOutgoing',
            scanInternal: 'scanInternal',
            scanIncomingHttp: 'scanIncomingHttp',
            scanIncomingSmtp: 'scanIncomingSmtp',
            scanIncomingFtp: 'scanIncomingFtp',
            scanOutgoingHttp: 'scanOutgoingHttp',
            scanOutgoingSmtp: 'scanOutgoingSmtp',
            scanOutgoingFtp: 'scanOutgoingFtp',
            scanInternalHttp: 'scanInternalHttp',
            scanInternalSmtp: 'scanInternalSmtp',
            scanInternalFtp: 'scanInternalFtp',
            track: 'track',
            trackValues: {
                log: 'LOG',
                alert: 'ALERT',
                none: 'NONE'
            },
            detectOnly: 'detectOnly',
            networks: 'networks',
            networkValues: {
                allInternal: 'ALL_INTERNAL',
                dmzToInternal: 'DMZ_TO_INTERNAL'
            }
        },
        antiSpam: {
            pageId: 'antiSpam',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            contentBasedFilter: 'contentBasedFilter',
            spamAction: 'spamAction',
            spamActionValues: {
                blockSpamEmails: 'BLOCK_SPAM_EMAILS',
                flagSpamEmailSubject: 'FLAG_SPAM_EMAIL_SUBJECT',
                flagSpamEmailHeader: 'FLAG_SPAM_EMAIL_HEADER',
            },
            track: 'track',
            trackValues: {
                log: 'LOG',
                alert: 'ALERT',
                none: 'NONE'
            },
            detectOnly: 'detectOnly',
            spamEmailSubject: 'spamEmailSubject'
        },
        qos: {
            pageId: 'qos',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            lowLatency: 'lowLatency',
            guarantee: 'guarantee',
            guaranteePercentage: 'guaranteePercentage',
            guaranteeTraffic: 'guaranteeTraffic',
            guaranteeTrafficValues: {
                vpnTraffic: 'VPN_TRAFFIC',
                allTraffic: 'ALL_TRAFFIC'
            },
            limitApps: 'limitApps',
            limitAppsDownload: 'limitAppsDownload',
            limitAppsUpload: 'limitAppsUpload',
            limitDownloadSize: 'limitDownloadSize',
            limitUploadSize: 'limitUploadSize',
        },
        remoteAccess: {
            pageId: 'remoteAccess',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            allowTraffic: 'allowTraffic',
            logTraffic: 'logTraffic',
        },
        siteToSiteVpn: {
            pageId: 'siteToSiteVPN',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            allowTraffic: 'allowTraffic',
            logTraffic: 'logTraffic'
        },
        userAwareness: {
            pageId: 'userAwareness',
            manageInSmp: 'manageInSmp',
            mode: 'mode'
        },
        antiVirus: {
            pageId: 'antiVirus',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            detect: 'detect'
        },
        antiBot: {
            pageId: 'antiBot',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            detect: 'detect',
            inspectSize: 'inspectSize'
        },
        threatEmulation: {
            pageId: 'threatEmulation',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            detect: 'detect',
            connectionHandlingModeHttp: 'connectionHandlingModeHttp',
            connectionHandlingModeHttpValues: {
                background: 'TE_CONNECTION_HANDLING_MODE.BACKGROUND',
                hold: 'TE_CONNECTION_HANDLING_MODE.HOLD'
            }
        },
        threatPrevention: {
            pageId: 'threatPrevention',
            manageInSmp: 'manageInSmp',
            highConfidence: 'highConfidence',
            mediumConfidence: 'mediumConfidence',
            lowConfidence: 'lowConfidence',
            confidenceValues: {
                ask: 'ASK',
                prevent: 'PREVENT',
                detect: 'DETECT',
                inactive: 'INACTIVE'
            },
            performanceImpact: 'performanceImpact',
            performanceImpactValues: {
                low: 'LOW',
                medium: 'MEDIUM',
                high: 'HIGH'
            },
            track: 'track',
            trackValues: {
                log: 'LOG',
                none: 'NONE',
                alert: 'ALERT'
            }
        },
        unifiedThreatPrevention: {
            pageId: 'unifiedThreatPrevention',
            manageInSmp: 'manageInSmp',
            highConfidence: 'highConfidence',
            mediumConfidence: 'mediumConfidence',
            lowConfidence: 'lowConfidence',
            confidenceValues: {
                ask: 'ASK',
                prevent: 'PREVENT',
                detect: 'DETECT',
                inactive: 'INACTIVE'
            },
            performanceImpact: 'performanceImpact',
            performanceImpactValues: {
                low: 'LOW',
                medium: 'MEDIUM',
                high: 'HIGH'
            },
            track: 'track',
            trackValues: {
                log: 'LOG',
                none: 'NONE',
                alert: 'ALERT'
            },
            policy: 'policy',
            policyValues: {
                strict: 'STRICT',
                recommended: 'RECOMMENDED',
                custom: 'CUSTOM'
            },
            severity: 'severity',
            severityValues: {
                low: 'LOW',
                medium: 'MEDIUM',
                high: 'HIGH',
                critical: 'CRITICAL'
            }
        },
        threatPreventionExceptions: {
            pageId: 'threatPreventionExceptions',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            whiteListUrls: 'allowlistUrls',
            whiteListUrlSchema: {
                value: 'value',
            },
        },
        sslInspection: {
            pageId: 'sslInspection',
            manageInSmp: 'manageInSmp',
            mode: 'mode',
            policy: 'policy',
            policySchema: {
                sslTrafficInspection: 'SSL_INSPECTION',
                httpsCategorization: 'HTTPS_CATEGORIZATION',

            },
            inspectHttps: 'inspectHttps',
            inspectImaps: 'inspectImaps',
            trustedNetworks: 'trustedNetworks',
            untrustedNetworks: 'untrustedNetworks',
            healthCategory: 'healthCategory',
            governmentCategory: 'governmentCategory',
            financeServiceCategory: 'financeServiceCategory',
            mediaCategory: 'mediaCategory',
            updateCategory: 'updateCategory',
            bypassOtherCategory: 'bypassOtherCategory',
            sslBlockList: 'sslBlockList',
            bypassCustomSites: 'bypassCustomSites',
            customSites: 'customSites',
            CpSSLBypassCustomSiteSchema: {
                name: 'name',
                value: 'value',
                regex: 'regex',
            },
            trackInspectLogs: 'trackInspectLogs',
            trackBypassLogs: 'trackBypassLogs',
            trackWirelessBypassLogs: 'trackWirelessBypassLogs',
        },
        managedServices: {
            pageId: 'managedServices',
            logs: 'logs',
            reports: 'reports',
            firmwareUpgrade: 'firmwareUpgrade',
            autoBackup: 'autoBackup',
            dynamicDns: 'dynDns',
            dynaminVpn: 'dynVpn',
            spp: 'spp',
            cloudNotifications: 'cloudNotifications'
        },
        firmware: {
            pageId: 'firmwareUpgrade',
            frequency: 'frequency',
            frequencyValues: {
                immediately: 'Immediately',
                daily: 'Daily',
                weekly: 'Weekly',
                monthly: 'Monthly'
            },
            time: 'time',
            weekDay: 'weekDay',
            monthDay: 'monthDay',
            mode: 'mode',
            modeValues: {
                specific: 'Specific',
                local: 'Local',
                latest: 'CpLatest',
                gradual: 'Gradual'
            },
            firmware: 'firmware',
            firmware1200: 'firmware1200',
            firmwareS1S2: 'firmwareS1S2',
            firmwareV0V1: 'firmwareV0V1',
            firmwareV2V3: 'firmwareV2V3',
            gradualFirmware: 'gradualFirmware',
            gradualFirmware1200: 'gradualFirmware1200',
            gradualFirmwareS1S2: 'gradualFirmwareS1S2',
            gradualFirmwareV0V1: 'gradualFirmwareV0V1',
            gradualFirmwareV2V3: 'gradualFirmwareV2V3',
            gradualUpgradeDelay: 'gradualUpgradeDelay',
            gradualUpgradePercentage: 'gradualUpgradePercentage',
            gradualUpgradeStartDate: 'gradualUpgradeStartDate',
            gradualUpgradeRunTime: 'gradualUpgradeRunTime'
        },
        serviceBackup: {
            pageId: 'serviceBackup',
            protocol: 'protocol',
            backupServerPath: 'backupServerPath',
            username: 'username',
            password: 'password',
            frequency: 'frequency',
            frequencyValues: {
                daily: 'DAILY',
                weekly: 'WEEKLY',
                monthly: 'MONTHLY'
            },
            dayOfWeek: 'dayOfWeek',
            dayOfWeekValues: {
                sunday: 'SUNDAY',
                monday: 'MONDAY',
                tuesday: 'TUESDAY',
                wednesday: 'WEDNESDAY',
                thursday: 'THURSDAY',
                friday: 'FRIDAY',
                saturday: 'SATURDAY'
            },
            dayOfMonth: 'dayOfMonth',
            backupTime: 'backupTime',
            useFileEncryption: 'useFileEncryption',
            passwordForEncrypt: 'passwordForEncrypt',
            confirmPasswordForEncrypt: 'confirmPasswordForEncrypt'
        },
        reports: {
            pageId: 'reports',
            reportsType: 'reportsType',
            reportsTypeValues: {
                gateway: 'Gateway',
                smartEvent: 'SmartEvent'
            },
            reportID: 'reportID',
            reportIDValues: 'reportIDValues',
            reportsConfirmationEnabled: 'reportsConfirmationEnabled',
            reportsDaily: 'reportsDaily',
            reportsWeekly: 'reportsWeekly',
            reportsMonthly: 'reportsMonthly',
            reportsLang: 'reportsLang',
            reportsLangValues: {
                english: 'ENGLISH',
                japanese: 'JAPANESE',
                hebrew: 'HEBREW',
                german: 'GERMAN'
            },
            reportAsHtmlBody: 'reportAsHtmlBody',
            reportsTimezone: 'reportsTimezone',
        },
        reportRecipients: {
            pageId: 'reportRecipients',
            sendToOwner: 'sendToOwner',
            additionalEmails: 'additionalEmails',
            additionalEmailsStr: 'additionalEmailsStr',
            unsubscribedEmails: 'unsubscribedEmails',
            unsubscribedEmailsStr: 'unsubscribedEmailsStr'
        },
        notifications: {
            pageId: 'notifications',
            notificationsMode: 'notificationsMode',
            notificationsLang: 'notificationsLang',
            notificationsLangValues: {
                english: 'ENGLISH',
                japanese: 'JAPANESE',
                hebrew: 'HEBREW',
                german: 'GERMAN'
            },
            infectedDevice: 'infectedDevice',
            fileBlocked: 'fileBlocked',
            fileDownloaded: 'fileDownloaded',
            emailReceived: 'emailReceived',
            emailBlocked: 'emailBlocked',
            deviceDetected: 'deviceDetected',
            deviceReconnected: 'deviceReconnected',
            primaryInternetRestored: 'primaryInternetRestored',
            primaryInternetDown: 'primaryInternetDown',
            gatewayUp: 'gatewayUp',
            unexpectedReboot: 'unexpectedReboot',
            newFirmware: 'newFirmware',
            licenseAboutToExpire: 'licenseAboutToExpire',
            licenseActivated: 'licenseActivated',
            licenseExpired: 'licenseExpired',
            hwEMMC: 'hwEmmcAboutToBeFull',
/*             vpnTunnelDown: 'vpnTunnelDown',
            vpnCertificateAboutToExpire: 'vpnCertificateAboutToExpire',
            vpnCertificateExpired: 'vpnCertificateExpired' */
        },
        notificationsRecipients: {
            pageId: 'notificationsRecipients',
            sendToOwner: 'sendToOwner',
            additionalEmails: 'additionalEmails',
            additionalEmailsStr: 'additionalEmailsStr',
            unsubscribedEmails: 'unsubscribedEmails',
            unsubscribedEmailsStr: 'unsubscribedEmailsStr'
        },
        dynamicDns: {
            pageId: 'dynamicDNS',
            primaryDomainName: 'primaryDomainName',
            dnsAliasList: 'dnsAliasList'
        },
        vpnCommunity: {
            pageId: 'vpnCommunity',
            communityDataList: 'communityDataList',
            communityDataSchema: {
                name: 'name',
                isCenter: 'isCenter'
            },
            noLocalConnsEncrypt: 'noLocalConnsEncrypt',
            useDnsName: 'useDnsName'
        },
        administratorAccess: {
            pageId: 'administratorAccess',
            adminAccessDataList: 'adminAccessDataList',
            adminAccessDataListSchema: {
                ipAddr: 'ipAddr',
                subnetMask: 'subnetMask',
                domainName: 'domainName',
                type: 'type',
                typeValues: {
                    ipAddress: 'IP Address',
                    network: 'Network'
                }
            }
        },
        gatewaysBehindNAT: {
            pageId: 'gatewaysBehindNAT',
            accessServiceUrl: 'accessServiceUrl',
            accessServiceMode: 'accessServiceMode',
            mgmtPort: 'mgmtPort',
            sicPort: 'sicPort'
        },
        cliScripts: {
            manageInSmp: 'manageInSmp',
            script: 'script',
            topicOrder: 'topicOrder',
            scriptRunRC: 'scriptRunRC',
            scriptRunText: 'scriptRunText',
            scriptRunTimestamp: 'scriptRunTimestamp',
            scriptDownloadRC: 'scriptDownloadRC',
            scriptDownloadText: 'scriptDownloadText',
            scriptDownloadTimestamp: 'scriptDownloadTimestamp',
        },
        cliScript1: {
            pageId: 'cliScript1',
            manageInSmp: 'manageInSmp',
            script: 'script',
            topicOrder: 'topicOrder',
            scriptRunRC: 'scriptRunRC',
            scriptRunText: 'scriptRunText',
            scriptRunTimestamp: 'scriptRunTimestamp',
            scriptDownloadRC: 'scriptDownloadRC',
            scriptDownloadText: 'scriptDownloadText',
            scriptDownloadTimestamp: 'scriptDownloadTimestamp',
        },
        cliScript2: {
            pageId: 'cliScript2',
            manageInSmp: 'manageInSmp',
            script: 'script',
            topicOrder: 'topicOrder',
            scriptRunRC: 'scriptRunRC',
            scriptRunText: 'scriptRunText',
            scriptRunTimestamp: 'scriptRunTimestamp',
            scriptDownloadRC: 'scriptDownloadRC',
            scriptDownloadText: 'scriptDownloadText',
            scriptDownloadTimestamp: 'scriptDownloadTimestamp',
        },
        cliScript3: {
            pageId: 'cliScript3',
            manageInSmp: 'manageInSmp',
            script: 'script',
            topicOrder: 'topicOrder',
            scriptRunRC: 'scriptRunRC',
            scriptRunText: 'scriptRunText',
            scriptRunTimestamp: 'scriptRunTimestamp',
            scriptDownloadRC: 'scriptDownloadRC',
            scriptDownloadText: 'scriptDownloadText',
            scriptDownloadTimestamp: 'scriptDownloadTimestamp',
        },
        cliScript4: {
            pageId: 'cliScript4',
            manageInSmp: 'manageInSmp',
            script: 'script',
            topicOrder: 'topicOrder',
            scriptRunRC: 'scriptRunRC',
            scriptRunText: 'scriptRunText',
            scriptRunTimestamp: 'scriptRunTimestamp',
            scriptDownloadRC: 'scriptDownloadRC',
            scriptDownloadText: 'scriptDownloadText',
            scriptDownloadTimestamp: 'scriptDownloadTimestamp',
        },
        cliScript5: {
            pageId: 'cliScript5',
            manageInSmp: 'manageInSmp',
            script: 'script',
            topicOrder: 'topicOrder',
            scriptRunRC: 'scriptRunRC',
            scriptRunText: 'scriptRunText',
            scriptRunTimestamp: 'scriptRunTimestamp',
            scriptDownloadRC: 'scriptDownloadRC',
            scriptDownloadText: 'scriptDownloadText',
            scriptDownloadTimestamp: 'scriptDownloadTimestamp',
        },
        cliScriptFromApi: {
            pageId: 'cliScriptFromAPI',
            manageInSmp: 'manageInSmp',
            script: 'script',
            topicOrder: 'topicOrder',
            scriptRunRC: 'scriptRunRC',
            scriptRunText: 'scriptRunText',
            scriptRunTimestamp: 'scriptRunTimestamp',
            scriptDownloadRC: 'scriptDownloadRC',
            scriptDownloadText: 'scriptDownloadText',
            scriptDownloadTimestamp: 'scriptDownloadTimestamp',
        },
        history: {
            pageId: 'history',
            createTime: 'createTime',
            lastTime: 'lastTime'
        }
    }
}

export const PlanGetListSchema = {
    name: 'name',
    description: 'desc',
    firewall: 'firewall',
    appsAndUrl: 'appsAndUrl',
    ips: 'ips',
    traditionalAntiVirus: 'traditionalAntiVirus',
    antiSpam: 'antiSpam',
    qos: 'qos',
    remoteAccess: 'remoteAccess',
    siteToSite: 'siteToSite',
    userAwareness: 'userAwareness',
    antiVirus: 'antiVirus',
    antiBot: 'antiBot',
    threatEmulation: 'threatEmulation',
    ssl: 'ssl',
    logging: 'logging',
    reports: 'reports',
    firmwareUpgrades: 'firmwareUpgrades',
    backup: 'backup',
    dynamicDns: 'dynamicDns',
    notifications: 'notifications',
    enabled: 'enabled'
}

export const NewPlanSchema = {
    name: 'name',
    description: 'description',
    storeGatewayLogs: 'storeGatewayLogs',
    sendPeriodicReports: 'sendPeriodicReports',
    firmwareUpgrades: 'firmwareUpgrades',
    dynamicDns: 'dynamicDns',
    sendCloudNotifications: 'sendCloudNotifications',
    firewall: 'firewall',
    applicationControlAndUrlFiltering: 'applicationControlAndUrlFiltering',
    ips: 'ips',
    traditionalAntiVirus: 'traditionalAntiVirus',
    antiSpam: 'antiSpam',
    qos: 'qos',
    remoteAccessVpn: 'remoteAccessVpn',
    siteToSiteVpn: 'siteToSiteVpn',
    userAwareness: 'userAwareness',
    antiVirus: 'antiVirus',
    antiBot: 'antiBot'
};

export const PlanFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    creationDate: 'creationDate',
    modificationDate: 'modificationDate'
}

export const PlanFeatureModes = {
    enabled: 'enabled',
    disabled: 'disabled',
    locallyManaged: 'local'
}
